module.exports = __webpack_public_path__ + "static/img/03.7b1f54c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/01/03.jpg
// module id = eDGf
// module chunks = 0